import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';

const showOverlay = (message, success, title = '') => {
  Swal.fire({
    title: title || (success ? 'Success' : 'Error!'),
    html: message,
    icon: success ? 'success' : 'error',
    confirmButtonText: 'Ok',
    position: 'top-center',
  });

  const networks = {
    '0xa86a': {
      chainId: '0xa86a',
      chainName: 'Avalanche C-Chain',
      nativeCurrency: {
        name: 'AVAX',
        symbol: 'AVAX',
        decimals: 18,
      },
      rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
      blockExplorerUrls: ['https://cchain.explorer.avax.network/'],
    },
    '0xa869': {
      chainId: '0xa869',
      chainName: 'Avalanche FUJI C-Chain',
      nativeCurrency: {
        name: 'AVAX',
        symbol: 'AVAX',
        decimals: 18,
      },
      rpcUrls: ['https://api.avax-test.network/ext/bc/C/rpc'],
      blockExplorerUrls: ['https://cchain.explorer.avax-test.network'],
    },
    '0x15b32': {
      chainId: '0x15b32',
      chainName: 'Chiliz Spicy Testnet',
      nativeCurrency: {
        name: 'CHZ',
        symbol: 'CHZ',
        decimals: 18,
      },
      rpcUrls: ['https://spicy-rpc.chiliz.com/'],
      blockExplorerUrls: ['https://spicy-explorer.chiliz.com/'],
    },
    '0x15b38': {
      chainId: '0x15B38',
      chainName: 'Chiliz Mainnet',
      nativeCurrency: {
        name: 'CHZ',
        symbol: 'CHZ',
        decimals: 18,
      },
      rpcUrls: ['https://rpc.ankr.com/chiliz/'],
      blockExplorerUrls: ['https://scan.chiliz.com/'],
    },
  };

  $('.js-network-check').on('click', async (e) => {
    const $that = $(e.currentTarget);
    const chainId = $that.data('chain-id');
    e.preventDefault();
    try {
      await window.ethereum.request({ method: 'wallet_addEthereumChain', params: [networks[chainId]] });
      console.log(networks, window.chainId);

      showOverlay('Network is changed successfully', true);

      window.location.reload(true);
    } catch (ex) {
      showOverlay(ex.message, false);
      console.log(networks, window.chainId);
    }
  });
};

export default showOverlay;
